import styled from "styled-components";
import { Flex, Button } from "antd";
import { CaretUpOutlined } from "@ant-design/icons";

// ─── Cell Container ────────────────────────────────────────────────────────────
// Flex handles: display, align-items, gap.
// styled adds only padding (not a Flex prop).

export const ProficiencyCellStyled = styled(Flex)`
  padding: 8px 0;
`;

// ─── Proficiency Visualizer ────────────────────────────────────────────────────
// Flex handles: display, flex-direction (vertical), flex growth (flex="1" in JSX).
// styled adds only min-width:0 — no Flex prop equivalent.

export const ProficiencyVisualizerStyled = styled(Flex)`
  min-width: 0;
`;

// ─── Progress Bar Wrapper ──────────────────────────────────────────────────────
// Must stay styled.div — position:relative is a positioning context, not a layout concern.

export const BarWrapperStyled = styled.div`
  position: relative;
`;

export const BarLabelStyled = styled.span`
  position: absolute;
  top: 0;
  height: 22px;
  line-height: 22px;
  font-size: 11px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  pointer-events: none;
  user-select: none;
  padding-right: 5px;
  transform: translateX(-100%);
  left: ${(p) => p.$left};
  z-index: 1;
`;

// ─── Required Proficiency Pointer ──────────────────────────────────────────────
// Must stay styled.div — position:relative with fixed height is a sizing concern.

export const PointerRowStyled = styled.div`
  position: relative;
  height: 28px;
  width: 100%;
  margin-top: -8px;
`;

// Extends AntD Flex; vertical + align + gap are set via props in JSX.
// styled adds only the absolute positioning — not replaceable by a Flex prop.

export const RequiredIndicatorStyled = styled(Flex)`
  position: absolute;
  left: ${(p) => p.$pct}%;
  transform: translateX(-50%);
  top: 0;
`;

export const RequiredCaretIconStyled = styled(CaretUpOutlined)`
  color: ${(p) => p.theme?.colors?.primary ?? "#008080"};
  font-size: 14px;
`;

export const RequiredValueStyled = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: ${(p) => p.theme?.colors?.primary ?? "#008080"};
  line-height: 1;
`;

// ─── +/- Buttons ──────────────────────────────────────────────────────────────
// Extends AntD Button; size, disabled state, cursor, flex centering handled by AntD.
// styled adds only visual overrides: flex-shrink, margin, border-radius, brand colors.

export const ProficiencyBtnStyled = styled(Button)`
  && {
    flex-shrink: 0;
    margin-top: -3px;
    border-radius: 6px;
    background: ${(p) =>
      p.disabled
        ? p.theme?.colors?.borderLight ?? "#E5E7EB"
        : p.theme?.colors?.secondary ?? "#DDEAEA"};
    border-color: ${(p) =>
      p.disabled
        ? p.theme?.colors?.borderLight ?? "#E5E7EB"
        : p.theme?.colors?.border ?? "#D8DAE5"};
    transition: background 0.15s, border-color 0.15s;

    &:hover:not(:disabled) {
      background: ${(p) => p.theme?.colors?.hoverBg ?? "rgba(1,85,231,0.08)"};
      border-color: ${(p) => p.theme?.colors?.primary ?? "#008080"};
    }
  }
`;
